// Tuning constants for the biome-ambience system

/** Weight per ring distance (index 0 = center hex, 1 = ring-1, etc.) */
export const RING_WEIGHTS = [3, 2, 1];

/** Minimum ms between biome evaluations */
export const EVAL_THROTTLE_MS = 200;

/** After switching biome, hold for this many ms before allowing another switch */
export const SWITCH_HOLD_MS = 1000;

/** New biome must beat current by this margin to trigger a switch */
export const HYSTERESIS = 0.20;

/** Minimum absolute confidence score to switch biomes */
export const MIN_CONFIDENCE_TO_SWITCH = 0.38;

/** Default crossfade duration in seconds */
export const DEFAULT_FADE_SEC = 2.5;
